import { render } from "./ListUsersProgress.vue?vue&type=template&id=08635144&scoped=true"
import script from "./ListUsersProgress.vue?vue&type=script&lang=js"
export * from "./ListUsersProgress.vue?vue&type=script&lang=js"

import "./ListUsersProgress.vue?vue&type=style&index=0&id=08635144&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-plataforma-ead\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08635144"]])

export default __exports__